import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import DySlider from '../components/DySlider/DySlider';

var DyPage = function DyPage(props) {
  return ReactDOM.createPortal(React.createElement(DySlider, {
    addVariantToCart: props.addVariantToCart,
    checkout: props.checkout,
    dySlug: props.dySlug,
    sliderId: props.sliderId
  }), document.getElementById(props.sliderId));
};
DyPage.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  dySlug: PropTypes.string.isRequired,
  checkout: PropTypes.object.isRequired,
  sliderId: PropTypes.string.isRequired
};

export default DyPage;